import oysterBank from '../Data/1_Austernbank.geojson';
import steinRiff from '../Data/2_FFH-Verdachtsfläche-Steinriff.geojson';
import windparkRiffgat from '../Data/3_riffgat_windpark.geojson';
import gasfelderData from '../Data/4_gasfelder.geojson';
import n05a from '../Data/6_n05_a_standort_bohrplattform.geojson';
import kabelData from '../Data/8_geplante_Kabeltrasse_original.geojson';
import gasPipeline from '../Data/9_Gas-Pipeline.geojson';
import riffgatRiff from '../Data/10_Riffgat-Riff.geojson';
import diveSites from '../Data/11_Tauchstandorte.geojson';
import naturschutzgebieteData from '../Data/13_Naturschutzgebiete_NSG.geojson';
import eezData from '../Data/14_Ausschließliche_Wirtschaftszone_AWZ.geojson';
import st999 from '../Data/St_999.geojson';
import borkumStone from '../Data/16_borkum_stenen.geojson';
import surveyAreaAugust from '../Data/17_SurveyArea_August.geojson';
import surveyAreaMarineSpace from '../Data/18_SideScan_Flaeche_2019.geojson';
import reefArea2019 from '../Data/reef_area_2019.geojson';
import reefArea2023 from '../Data/reef_area_2023.geojson';
import eez12nmLinesData from '../Data/19_eez12nm_lines.geojson';
import noordzeekustzoneData from '../Data/20_NL9802001.geojson';

//import n404 from '../Data/5_n04_4_bohrplattform.geojson';
//import n05aRichtung from '../Data/7_n05-a-Bohrplattform_Richtbohrungen.geojson';
//import diveAreas from '../Data/12_Untersuchungsgebiete.geojson';
//import protectedAreas from '../Data/15_Steinansammlungen_inklusive.geojson';

import diveIcon from '../Images/markers/dive-icon.png'
import blackHash from '../Images/patterns/hash_black.png';
import blueHash from '../Images/patterns/hash_blue.png';

// Main configuration
export const MAPBOX_TOKEN = 'pk.eyJ1IjoiZ3JlZW5wZWFjZWdtaCIsImEiOiJja3BpNTdrcTQwMGFwMnVsajN1encyamE3In0.1qRAZvB6vqzMjrO_eGFLew';
export const DEFAULT_COORDS = [6.36, 53.68577924];
export const DEFAULT_ZOOM = 11;
export const WEBSITE = `//maps.greenpeace.org/maps/gpde/nl-drilling`;

export const LAYERS = {
	'gasfelder': {
		type: 'polygon',
		name: 'gasfelder',
		title: 'Gasfelder / Gas Fields',
		data: gasfelderData,
		state: true,
		paint: {
			'fill-color': '#bcb621',
			'fill-opacity': 0.5,
		},
		beforeId: 'oyster_bank',
	},
	'n05a': {
		type: 'circle',
		name: 'n05a',
		title: 'N05A- geplante Bohrplattform / planned Gas Drilling Platform',
		data: n05a,
		state: true,
		paint: {
			'circle-radius': 8,
			'circle-stroke-color': 'white',
			'circle-stroke-width': 2,
			'circle-color': 'black'
		},
	},
	'kabeltrasse': {
		type: 'polygon',
		polyline: true,
		name: 'kabeltrasse',
		title: 'Kabeltrasse / Cable Route',
		data: kabelData,
		state: true,
		paint: {
			'line-color': '#974e4e',
			'line-width': 3
		}
	},
	'gasPipeline': {
		type: 'polygon',
		polyline: true,
		name: 'gasPipeline',
		title: 'Gas-Pipeline',
		data: gasPipeline,
		state: true,
		paint: {
			'line-opacity': 0.5,
			'line-color': '#0814b4',
			'line-width': 4
		}
	},
	'diveSites': {
		type: 'point',
		name: 'diveSites',
		data: diveSites,
		title: 'Tauchstandorte - Greenpeace 2023 (May) / Diving positions',
		icon: diveIcon,
		state: true,
		layout: {
			'icon-size': 0.8,
		},
		beforeId: 'n05a'
	},
	'reef_area_2019': {
		type: 'polygon',
		name: 'reef_area_2019',
		title: 'Riffgebiet / Reef area, 2019',
		data: reefArea2019,
		state: true,
		paint: {
			'fill-color': '#a52a2a',
			'fill-opacity': 0.5,
		},
		outlineColor: '#a52a2a',
		outlineWidth: 1,
		outlineOpacity: 1,
		beforeId: 'oyster_bank',
	},
	'reef_area_2023': {
		type: 'polygon',
		name: 'reef_area_2023',
		title: 'Riffgebiet / Reef area, 2023',
		data: reefArea2023,
		state: true,
		paint: {
			'fill-color': '#4e6570',
			'fill-opacity': 0.5,
		},
		outlineColor: '#4e6570',
		outlineWidth: 1,
		outlineOpacity: 1,
		beforeId: 'reef_area_2019',
	},
	'riffgat_wind_park': {
		type: 'polygon',
		name: 'riffgat_wind_park',
		title: 'Windpark Riffgat / Offshore Windfarm OWF Riffgat',
		data: windparkRiffgat,
		state: true,
		patternImageName: 'hashPatternBlack',
		patternImageUrl: blackHash,
		outlineColor: 'black',
		outlineWidth: 2,
		outlineOpacity: 1
	},
	'naturschutzgebiete': {
		type: 'polygon',
		name: 'naturschutzgebiete',
		title: 'NSG Naturschutzgebiete / Nature Reserves: Borkum Riffgrund; Borkum Riff; Nationalpark Niedersächsisches Wattenmeer',
		data: naturschutzgebieteData,
		state: true,
		paint: {
			'fill-color': '#6d87ba',
			'fill-opacity': 0.4,
		},
		beforeId: 'reef_area_2023'
	},
	'eez12nm': {
		type: 'polygon',
		polyline: true,
		name: 'eez12nm',
		title: 'Küstenmeer / Coastal Sea',
		data: eez12nmLinesData,
		interactive: false,
		state: true,
		paint: {
			'line-color': 'black',
			'line-width': 2,
			'line-dasharray': [3, 3],
		},
		beforeId: 'diveSites'
	},
	'eez': {
		type: 'polygon',
		name: 'eez',
		title: 'AWZ Ausschließliche Wirtschaftszone / Exclusive Economic Zone',
		data: eezData,
		interactive: false,
		labelField: 'geoname',
		state: true,
		paint: {
			'fill-opacity': 0,
		},
		outlineColor: 'grey',
		outlineWidth: 2,
		outlineOpacity: 0.5,
		beforeId: 'diveSites'
	},
	'NL9802001': {
		type: 'polygon',
		name: 'NL9802001',
		title: 'Noordzeekustzone',
		data: noordzeekustzoneData,
		state: true,
		patternImageName: 'hashPatternBlue',
		patternImageUrl: blueHash,
		outlineColor: '#1d94ef',
		outlineWidth: 2,
		outlineOpacity: 1
	},
	'borkumSteine': {
		type: 'polygon',
		name: 'borkumSteine',
		title: 'Borkumse Stenen',
		data: borkumStone,
		state: false,
		paint: {
			'fill-color': '#1d94ef',
			'fill-opacity': 0.1,
		},
		outlineColor: '#1d94ef',
		outlineWidth: 2,
		outlineOpacity: 1,
		beforeId: 'oyster_bank'
	},
	'riffgatRiff': {
		type: 'polygon',
		name: 'riffgatRiff',
		title: 'Riffgat Riff / Riffgat Reef - Submaris 2021',
		data: riffgatRiff,
		state: false,
		paint: {
			'fill-opacity': 0,
		},
		outlineColor: 'black',
		outlineWidth: 3,
		outlineOpacity: 1
	},
	'stein_riff': {
		type: 'polygon',
		name: 'stein_riff',
		title: 'FFH-Verdachtsfläche (Steinriff)',
		data: steinRiff,
		state: false,
		paint: {
			'fill-color': '#ea8515',
			'fill-opacity': 0.7,
		},
		beforeId: 'oyster_bank'
	},
	'oyster_bank': {
		type: 'polygon',
		name: 'oyster_bank',
		title: 'Austernbank / Oyster Bank',
		data: oysterBank,
		state: false,
		paint: {
			'fill-color': '#109bea',
			'fill-opacity': 0.5,
		},
		beforeId: 'diveSites'
	},
	'survey_area_august': {
		type: 'polygon',
		name: 'survey_area_august',
		title: 'Untersuchungsgebiete (Side Scan Sonar) / Survey Areas, Greenpeace 2023 (August / September)',
		data: surveyAreaAugust,
		state: false,
		paint: {
			'fill-opacity': 0,
		},
		outlineColor: '#673ab7',
		outlineWidth: 2,
		outlineOpacity: 1,
		beforeId: 'reef_area_2023'
	},
	'survey_area_ms2022': {
		type: 'polygon',
		name: 'survey_area_ms2022',
		title: 'Untersuchungsgebiete (Side Scan Sonar) / Survey Area, Marine Space 2022',
		data: surveyAreaMarineSpace,
		state: false,
		paint: {
			'fill-opacity': 0,
		},
		outlineColor: '#009688',
		outlineWidth: 2,
		outlineOpacity: 1,
		beforeId: 'reef_area_2023'
	},
	'st999': {
		type: 'circle',
		name: 'st999',
		title: 'Stone 999',
		data: st999,
		state: false,
		paint: {
			'circle-stroke-color': 'white',
			'circle-stroke-width': 2,
			'circle-color': '#ffc107'
		},
	},
	/*
	'n404': {
		type: 'circle',
		name: 'n404',
		title: 'N04-4-Bohrplattform',
		data: n404,
		state: false,
		paint: {
			'circle-stroke-color': 'white',
			'circle-stroke-width': 2,
			'circle-color': '#001bff'
		},
	},
	'n05aRichtung': {
		type: 'polygon',
		polyline: true,
		name: 'n05aRichtung',
		title: 'N05-A-Bohrplattform mit Richtbohrungen',
		data: n05aRichtung,
		state: false,
		paint: {
			'line-opacity': 0.5,
			'line-color': 'black',
			'line-width': 1
		}
	},
	'diveAreas': {
		type: 'polygon',
		name: 'diveAreas',
		title: 'Untersuchungsgebiete (Side Scan Sonar), Greenpeace 2023 (May) / Survey Areas',
		data: diveAreas,
		interactive: true,
		state: false,
		paint: {
			'fill-opacity': 0.4,
			'fill-color': '#e70000'
		},
		outlineColor: '#e70000',
		outlineWidth: 2,
		outlineOpacity: 1,
		beforeId: 'diveSites'
	},
	'protectedAreas': {
		type: 'polygon',
		name: 'protectedAreas',
		title: 'Steinansammlungen inklusive geogene Riffe (Typ: "Steinfeld/Blockfeld" nach BfN)',
		data: protectedAreas,
		state: false,
		paint: {
			'fill-color': '#66cc00',
			'fill-opacity': 0.9,
		},
	}
	*/
};

export const LAYER_TYPE_COLUMN = 'layer';
export const DEFAULT_LANG = 'de';
export const CACHE_LIFETIME = 1;//3600000; // 1 hour
export const GOOGLE_LANGUAGES_SPREADSHEET_ID = '1LCpTa-JktOivfcPS9BKouD7cgZCVZuIugym9h2EO7tg';